import { render, staticRenderFns } from "./taskNewLists.vue?vue&type=template&id=978b818e&scoped=true&"
import script from "./taskNewLists.vue?vue&type=script&lang=js&"
export * from "./taskNewLists.vue?vue&type=script&lang=js&"
import style0 from "./taskNewLists.vue?vue&type=style&index=0&id=978b818e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978b818e",
  null
  
)

export default component.exports